import { type PayableRuleSchemaWithStats } from '@spendesk/bookkeeping-core-types';

import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

export const getPayableRulesQueryKey = [
  'bookkeeping',
  'automation',
  'payable-rules',
];
export const useGetPayableRules = (
  isEnabled: boolean,
): QueryState<PayableRuleSchemaWithStats> => {
  return useQuery({
    key: getPayableRulesQueryKey,
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/bookkeeping/automation/payable-rules`,
    },
    isEnabled,
    reshapeData: (data) => {
      return data;
    },
  });
};
